import { DashboardService } from './../../../../services/dashboard.service';
import { AdminService } from './../../../../services/admin.service';
import { OrganisationService } from 'src/app/services/organisation.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {first, map, debounceTime, distinctUntilChanged, tap, concatMap} from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import * as jquery from 'jquery';
import { fromEvent } from 'rxjs';
import {Chart} from "chart.js";
import { NgbDate, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import * as moment from "moment-timezone";

@Component({
  selector: 'organisation-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss'],
  providers: [DatePipe]
})
export class OrganisationEditComponent implements OnInit {

  users = [];
  organisation = [];
  search_name: string;
  success = false;
  successMessage: string;
  organisationId: number;

  domainError = '';
  domainFreeTrialError = '';
  nameError = '';
  name: string;
  status: string;
  domains: string;
  freeTrials: string;
  freeTrialDisplay: string;
  created: number;
  users_total: number;
  orgType: string;
  orgId: number;
  total_users: number;

  currentPage: number;
  lastPage: number;
  pageLinks: number[] = [];
  searchValue = '';
  processingSearch = 0;

  updateNameForm: FormGroup;
  updateDomainForm: FormGroup;
  updateTypeForm: FormGroup;
  updateFreeTrialForm: FormGroup;
  updateTotalUsersForm: FormGroup;
  submitted = false;
  error = false;
  errorMsg: string;
  loading = false;
  modalText = 'Loading...';

  domainRows: any[] = [];
  freeTrialRows: any[] = [];
  voucherRows: any[] = [];
  newDomain: any;
  newFreeTrial: any;

  nameAlreadyUsed = false;
  domainReqErr = false;
  freeTrialFormatErr = false;
  voucherErr = false;
  enterpriseTypeErr = false;
  enterpriseNameReqErr = false;

  chartLogins: any;
  chartVideos: any;
  chartPoints: any;
  chart: any;

  loginData = [];
  loginLabels = [];
  videoData = [];
  videoLabels = [];
  pointsData = [];
  pointsLabels = [];

  myDate = new Date();
  today: string;
  todayYmd: string;

  hoveredDate: NgbDate | null = null;
  toDate: NgbDate | null;
  toUnixTimestamp = '';
  dpToDate: NgbDate;

  voucherString = '';
  voucherDuplicate = false;
  voucherDuplicateEntry = false;
  deleteVoucherCode = '';
  deleteVoucherIndex = 0;
  voucherSuccessfullyDeleted = false;

  constructor(
    private route: ActivatedRoute,
    private organisationService: OrganisationService,
    private adminService: AdminService,
    private dashboardService: DashboardService,
    private datePipe: DatePipe,
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter
  ) { }

  // Convenience getter for easy access to form fields
  get fname() { return this.updateNameForm.controls; }
  get fdomain() { return this.updateDomainForm.controls; }
  get ffreeTrial() { return this.updateFreeTrialForm.controls; }
  get ftype() { return this.updateTypeForm.controls; }
  get ftotalusers() { return this.updateTotalUsersForm.controls; }

  ngOnInit(): void {
    this.organisationId = this.route.snapshot.params.organisationId;
    this.setFormControls();
    this.getOrgDetails();
    //this.addDomainRow();
    this.today = this.datePipe.transform(this.myDate, 'd MMM yyyy');
    this.todayYmd = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
  }

  setFormControls() {
    this.updateNameForm = new FormGroup({
      name: new FormControl(this.name, [
        Validators.required
      ])
    });
    this.updateDomainForm = new FormGroup({
      domains: new FormControl(this.domains, [
        Validators.required
      ])
    });
    this.updateFreeTrialForm = new FormGroup({
      freeTrials: new FormControl(this.freeTrials, [
        Validators.required
      ])
    });
    this.updateTypeForm = new FormGroup({
      type: new FormControl(this.orgType, [
        Validators.required
      ])
    });
    this.updateTotalUsersForm = new FormGroup({
      total_users: new FormControl(this.total_users, [
        Validators.required,
        Validators.min(1)
      ])
    });
  }

  getOrgDetails() {
    // Show progress modal
    this.showProgressModal();

    this.organisationService.details(this.organisationId)
      .pipe(first())
      .subscribe(
        data => {
          // console.log(data.data.organisation.users);
          const org = data.data.organisation;
          this.orgId = org.id;
          this.name = org.name;
          this.status = org.status;
          this.domains = org.domains;
          this.freeTrials = org.free_trials;
          this.created = org.created;
          this.users_total = org.users;
          this.orgType = org.type;
          this.total_users = org.total_users;
          this.loadUsers();

          this.updateNameForm.setValue({
            name: this.name
          });

          // domain
          let domainString = org.domains.split(',');
          for (let index = 0; index < domainString.length; ++index) {

            this.domainRows.push({
              id: 0,
              sequence: this.domainRows.length + 1,
              text: domainString[index].trim()
            });

          }

          // free trials
          let freeTrialString = org.free_trials.split(',');
          for (let index = 0; index < freeTrialString.length; ++index) {

            this.freeTrialRows.push({
              id: 0,
              sequence: this.freeTrialRows.length + 1,
              text: freeTrialString[index].trim()
            });

            if (index == 0) {
              this.freeTrialDisplay = freeTrialString[index].trim();
            }

            if (index == 1) {
              this.freeTrialDisplay = this.freeTrialDisplay + " and more...";
            }
          }

          // vouchers
          let voucherArray = org.vouchers;
          if (voucherArray.length == 0) {
            this.addVoucherRow();
          } else {
            for (let index = 0; index < voucherArray.length; ++index) {
              if (index == 0) { this.voucherString = voucherArray[index].code; }
              if (index == 1) { this.voucherString = this.voucherString + " and more..."; }
              let expiry = this.datePipe.transform(voucherArray[index].expiry_date * 1000, 'dd-MM-yyyy +1200');
              this.voucherRows.push({code: voucherArray[index].code,
                                    expiry_date: expiry,
                                    max_users: voucherArray[index].max_users,
                                    current_users: voucherArray[index].current_users,
                                    new: false });
            }
          }

          this.updateTypeForm.setValue({
            type: this.orgType
          });

          setTimeout(() => {
            // hide progress modal
            //this.hideProgressModal();
          }, 500);

        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  search() {
    const searchBox = document.getElementById('searchUserInput');
    if (searchBox) {
      const keyup$ = fromEvent(searchBox, 'keyup');
      keyup$
        .pipe(
          map((event: any) => {
            this.searchValue = event.target.value;
            return event.target.value;
          }),
          debounceTime(2000),
          distinctUntilChanged()
        )
        .subscribe((text: string) => {
          this.modalText = (text !== '') ? 'Searching...' : 'Loading...';
          this.loadUsers(1, this.searchValue);
        });
    }
  }

  loadUsers(pageNumber: number = 1, searchValue: string = '', organisation: number = this.organisationId) {
    if (this.processingSearch == 0) {

      // Show progress modal
      this.showProgressModal();

      this.processingSearch = 1;
      this.adminService.adminList(pageNumber, searchValue, organisation)
        .pipe(first())
        .subscribe(data => {
          // console.log(data);
          this.users = data.data.users;
          const totalRecords = data.data.pagination?.total_records;
          this.lastPage = data.data.pagination?.last_page;
          this.pageLinks = [];
          if (totalRecords > 0) {
            this.currentPage = data.data.pagination?.current_page;
            for (let index = 1; index <= this.lastPage; index++) {
              this.pageLinks.push(index);
            }
          }
          this.processingSearch = 0;

          setTimeout(() => {
            // hide progress modal
            this.hideProgressModal();
            this.loadData();
          }, 500);

          setTimeout(() => {
            this.search();
          }, 0);

        });

    }
  }

  paginate(pageNumber: number) {
    if (pageNumber > 0) {
      this.loadUsers(pageNumber, this.searchValue);
    }
  }

  roleUpdate(event: any) {
    const value = event.target.checked;
    const userId = event.target.value;
    const orgId = this.orgId;

    let role = 'individual';
    if (value) {
      role = 'manager';
    }

    this.adminService.adminUpdateUserRole(userId, role, orgId)
      .pipe(first())
      .subscribe(data => {
      });
  }

  updateName() {
    // Stop here if there's form errors
    this.submitted = true;
    if (this.updateNameForm.invalid) {
      return;
    }
    this.update(this.fname.name.value);
  }

  updateTotalUsers() {
    // Stop here if there's form errors
    this.submitted = true;
    if (this.updateTotalUsersForm.invalid) {
      return;
    }
    this.update('', '', '', '', '', '', this.ftotalusers.total_users.value);
  }


  updateType() {
    // Stop here if there's form errors
    this.submitted = true;
    if (this.updateTypeForm.invalid) {
      return;
    }
    this.update('', '', '', this.ftype.type.value);
  }

  updateDomain() {
    // Stop here if there's form errors
    this.submitted = true;
    let newDomainString = "";
    let newDomain = [];

    this.domainRows.forEach((domain, dIndex) => {
      if (domain.text == '') {
        if (dIndex == 0) {
          this.domainReqErr = true;
        }
      } else {
        newDomain.push(domain.text);
      }
    });

    if (!this.domainReqErr) {
      newDomainString = newDomain.join();
      this.update('', newDomainString);
    }
  }

  updateFreeTrial() {
    // Stop here if there's form errors
    this.submitted = true;
    let newFreeTrialString = "";
    let newFreeTrial = [];

    this.freeTrialRows.forEach((freeTrial, dIndex) => {

      if (freeTrial.text != '' && typeof freeTrial.text != 'undefined') {
        if (!this.validateEmail(freeTrial.text)) {
          this.freeTrialFormatErr = true;
          jquery('#freeTrialInput_'+dIndex+'').addClass('error');
          jquery('#freeTrialError_'+dIndex+'').removeClass('d-none');
          jquery('#freeTrialError_'+dIndex+'').text("Invalid email format");
        } else {
          newFreeTrial.push(freeTrial.text);
        }
      }
    });


    if (!this.freeTrialFormatErr) {
      this.freeTrialDisplay = "";

      for (let index = 0; index < newFreeTrial.length; ++index) {
        if (index == 0) {
          this.freeTrialDisplay = newFreeTrial[index].trim();
        }
        if (index == 1) {
          this.freeTrialDisplay = this.freeTrialDisplay + " and more...";
        }
      }

      newFreeTrialString = newFreeTrial.join();
      this.update('', '', '', '', newFreeTrialString);
    }
  }

  updateStatus(status) {
    this.submitted = true;
    this.update('', '', status);
  }

  update(name = '', domain = '', status = '', type = '', freeTrial = '', voucher = '', total_users = 0) {

    if (name) { this.successMessage = 'Enterprise name successfully updated.'; }
    else if (domain) { this.successMessage = 'Enterprise domain successfully updated.'; }
    else if (status) { this.successMessage = 'Enterprise status successfully updated.'; }
    else if (type) { this.successMessage = 'Enterprise type successfully updated.'; }
    else if (freeTrial) { this.successMessage = 'Free trial successfully updated.'; }
    else if (total_users) { this.successMessage = 'Company size successfully updated.'; }
    else { this.successMessage = 'Voucher successfully updated.'; }
    this.voucherDuplicate = false;

    this.error = false;
    this.loading = true;
    this.success = false;
    this.organisationService.update(this.organisationId, name, domain, status, type, freeTrial, voucher, total_users)
      .pipe(first())
      .subscribe(
        data => {
          this.loading = false;
          if (data.success) {
            jquery('.close').click();
            this.success = true;
            setTimeout(() => {
              this.success = false;
            }, 4000);
            if (name) {
              this.name = name;
            }
            if (domain) {
              this.domains = domain;
            }
            if (status) {
              this.status = status;
            }
            if (type) {
              this.orgType = type;
            }
            if(freeTrial) {

            }
            if (total_users) {
              this.total_users = total_users;
            }

            // vouchers
            this.voucherRows = [];
            let voucherArray = data.data.vouchers;
            if (voucherArray.length != 0) {
              for (let index = 0; index < voucherArray.length; ++index) {
                if (index == 0) { this.voucherString = voucherArray[index].code; }
                if (index == 1) { this.voucherString = this.voucherString + " and more..."; }
                let expiry = this.datePipe.transform(voucherArray[index].expiry_date * 1000, 'dd-MM-yyyy');
                this.voucherRows.push({ code: voucherArray[index].code,
                                        expiry_date: expiry,
                                        max_users: voucherArray[index].max_users,
                                        current_users: voucherArray[index].current_users,
                                        new: false });
              }
            } else {
              this.voucherString = '';
            }

          } else {
            if (data.data.domain) {
              for (var key in data.data.domain.error[0]) {
                jquery('#domainInput_'+key+'').addClass('error');
                jquery('#domainError_'+key+'').removeClass('d-none');
                jquery('#domainError_'+key+'').text(data.data.domain.msg[0]);
              }
            }

            if (data.data.free_trial) {
              for (var key in data.data.free_trial.error[0]) {
                jquery('#freeTrialInput_'+key+'').addClass('error');
                jquery('#freeTrialError_'+key+'').removeClass('d-none');
                jquery('#freeTrialError_'+key+'').text(data.data.free_trial.msg[0]);
              }
            }

            if (data.data.voucher) {
              this.voucherDuplicate = true;
              let voucherCodeErr = data.data.voucher.error[0];
              jquery('#voucherCode_'+voucherCodeErr+'').css('border-bottom', '1px solid red');
            }

          }
        }, error => {
          this.loading = false;
          this.error = true;
          this.submitted = true;
          if (error.error.data.name) {
            this.updateNameForm.controls['name'].setErrors({
              'error': true
            });
            this.nameError = error.error.data.name;
          }
        });
  }

  addDomainRow() {
    this.domainRows.push({
      id: 0,
      sequence: this.domainRows.length + 1,
      text: ''
    });
  }

  addFreeTrialRow() {
    this.freeTrialRows.push({
      id: 0,
      sequence: this.freeTrialRows.length + 1,
      text: ''
    });
  }

  onKeyUpDomain(i) {
    this.domainReqErr = false;
    jquery('#domainInput_'+i+'').removeClass('error');
    jquery('#domainError_'+i+'').addClass('d-none');
    jquery('#domainError_'+i+'').text('');
  }

  onKeyUpFreeTrial(i) {
    this.freeTrialFormatErr = false;
    jquery('#freeTrialInput_'+i+'').removeClass('error');
    jquery('#freeTrialError_'+i+'').addClass('d-none');
    jquery('#freeTrialError_'+i+'').text('');
  }

  deleteDomainRow(index) {
    this.domainRows.splice(index, 1);
  }

  deleteFreeTrialRow(index) {
    this.freeTrialRows.splice(index, 1);
  }

  private showProgressModal() {
    jquery('#loaderSpin').show();
  }

  private hideProgressModal() {
    jquery('#loaderSpin').hide();
  }

  lastWeek() {
    this.myDate.setDate(this.myDate.getDate() - 7);
    this.today = this.datePipe.transform(this.myDate, 'd MMM yyyy');
    this.todayYmd = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
    this.loginData = [];
    this.loginLabels = [];
    this.videoData = [];
    this.videoLabels = [];
    this.pointsData = [];
    this.pointsLabels = [];
    this.loadData();
  }

  nextWeek() {
    this.myDate.setDate(this.myDate.getDate() + 7);
    this.today = this.datePipe.transform(this.myDate, 'd MMM yyyy');
    this.todayYmd = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
    this.loginData = [];
    this.loginLabels = [];
    this.videoData = [];
    this.videoLabels = [];
    this.pointsData = [];
    this.pointsLabels = [];
    this.loadData();
  }

  loadData() {

    // Show progress modal
    this.showProgressModal();

    this.loginData = [];
    this.loginLabels = [];
    this.videoData = [];
    this.videoLabels = [];
    this.pointsData = [];
    this.pointsLabels = [];

    this.adminService.getProfile()
      .pipe(

        // Get User Details
        map(user => user.data.user),
        tap(user => {
          //this.userNavigation.user = user;
        }),

        // Get Login Data
        concatMap(() => this.dashboardService.userLoginsAdmin(this.todayYmd, this.organisationId)),
        map(loginData => loginData.data),
        tap(loginData => {
          loginData.dates.forEach(value => {
            this.loginData.push(value.logins);
            this.loginLabels.push(value.date);
          });

          this.loadChart('chartLogins', 'canvas-logins', 'logins', this.loginLabels, this.loginData);
        }),

        // Get Video Data
        concatMap(() => this.dashboardService.userVideosAdmin(this.todayYmd, this.organisationId)),
        map(videoData => videoData.data),
        tap(videoData => {
          videoData.dates.forEach(value => {
            this.videoData.push(value.videos);
            this.videoLabels.push(value.date);
          });
          this.loadChart('chartVideos', 'canvas-videos', 'videos', this.videoLabels, this.videoData);
        }),

        // Get Points Data
        concatMap(() => this.dashboardService.userPointsAdmin(this.todayYmd, this.organisationId)),
        map(pointsData => pointsData.data),
        tap(pointsData => {
          pointsData.dates.forEach( value => {
            this.pointsData.push(value.points);
            this.pointsLabels.push(value.date);
          });
          this.loadChart('chartPoints', 'canvas-points', 'points', this.pointsLabels, this.pointsData);
        }),

      )
      .subscribe(
        response => {
          if (response) {
            setTimeout(() => {
              // hide progress modal
              this.hideProgressModal();
            }, 500);
          }
        },
        error => {
          console.log(error);
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  loadChart(dataname = '', canvas_id = '', label = '', labels, data) {
    this[dataname] = new Chart(canvas_id, {
      type: 'line',
      data: {
        labels: labels,
        datasets: [{
          label: label,
          data: data,
          backgroundColor: ['rgba(1, 107, 132, 0.1)'],
          borderColor: ['rgba(1, 107, 132, 1)'],
          borderWidth: 2
        }]
      },
      options: {
        maintainAspectRatio: false,
        spanGaps: false,
        elements: {
          line: {
            tension: 0.000001
          }
        },
        plugins: {
          filler: {
            propagate: false
          }
        },
        legend: {
          display: false,
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize: 1
            }
          }]
        }
      }
    });
  }

  private validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  onlyNumberKey(event) {
    return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
  }

  onDateToSelection(toDate: NgbDate) {
    this.toDate = toDate;
    const toDateF = this.toDate.day + '/' + this.toDate.month + '/' + this.toDate.year;
  }

  addVoucherRow() {
    this.voucherRows.push({
      sequence: this.voucherRows.length + 1,
      code: '',
      expiry_date: '',
      max_users: '',
      current_users: 0,
      new: true
    });
  }

  updateVouchers() {

    let codeList = [];
    let newVouchers = [];
    let newVoucherString = "";
    this.submitted = true;
    this.voucherErr = false;
    this.voucherDuplicate = false;
    this.voucherDuplicateEntry = false;
    this.voucherSuccessfullyDeleted = false;

    jquery('.voucherCode').css('border-bottom', '1px solid #CACACA');
    jquery('.voucherExpiry').css('border-bottom', '1px solid #CACACA');
    jquery('.voucherMaxUser').css('border-bottom', '1px solid #CACACA');

    this.voucherRows.forEach((voucher, dIndex) => {
      if ( voucher.code === "" && ( voucher.expiry_date != "" || voucher.max_users != "" ) ) {
        jquery('#voucherCode_'+dIndex+'').css('border-bottom', '1px solid red');
        this.voucherErr = true;
      }

      if ( voucher.expiry_date === "" && ( voucher.code != "" || voucher.max_users != "" ) ) {
        jquery('#voucherExpiry_'+dIndex+'').css('border-bottom', '1px solid red');
        this.voucherErr = true;
      }

      if ( voucher.max_users === "" && ( voucher.expiry_date != "" || voucher.code != "" ) ) {
        jquery('#voucherMaxUser_'+dIndex+'').css('border-bottom', '1px solid red');
        this.voucherErr = true;
      }

      codeList.push(voucher.code);

      let sorted_arr = codeList.sort();
      for (var i = 0; i < codeList.length - 1; i++) {
        if (sorted_arr[i + 1] == sorted_arr[i]) {
          jquery('#voucherCode_'+dIndex+'').css('border-bottom', '1px solid red');
          this.voucherErr = true;
          this.voucherDuplicateEntry = true;
        }
      }

      if ( voucher.code != "" && voucher.expiry_date != "" && voucher.max_users != "" ) {
        newVouchers.push({
          code: voucher.code,
          expiry_date: voucher.expiry_date,
          max_users: voucher.max_users
        });
      }

    });

    if (!this.voucherErr) {
      newVoucherString = JSON.stringify(newVouchers);
      this.update('', '', '', '', '', newVoucherString);
    }
  }

  deleteVoucherRow(index, code, newRow) {
    this.deleteVoucherCode = code;
    this.deleteVoucherIndex = index;
    if ( newRow || jquery('#voucherCode_'+index+'').val() === "" || jquery('#voucherExpiry_'+index+'').val() === "" || jquery('#voucherMaxUser_'+index+'').val() === "" ) {
      this.voucherRows.splice(this.deleteVoucherIndex, 1);
    } else {
      document.getElementById('openDeleteConfirmModal').click();
    }
  }

  deleteVoucherRowConfirm() {
    this.showProgressModal();
    this.organisationService.deleteVoucher(this.organisationId, this.deleteVoucherCode)
      .pipe(first())
      .subscribe(
      data => {
          this.voucherRows.splice(this.deleteVoucherIndex, 1);
          document.getElementById('deleteVoucherCancel').click();
          this.voucherSuccessfullyDeleted = true;
          this.hideProgressModal();

          // update voucher display text
          let voucherArray = this.voucherRows;
          if (voucherArray.length != 0) {
            for (let index = 0; index < voucherArray.length; ++index) {
              if (index == 0) { this.voucherString = voucherArray[index].code; }
              if (index == 1) { this.voucherString = this.voucherString + " and more..."; }
            }
          } else {
            this.voucherString = '';
          }
        }
      );
  }

  openUpdateNameModal() {
    this.getOrgName();
    document.getElementById('openUpdateNameModal').click();
  }

  getOrgName() {
    this.name = "";
    this.organisationService.details(this.organisationId)
      .pipe(first())
      .subscribe(
        data => {
          const org = data.data.organisation;
          // org name
          this.name = org.name;
          this.updateNameForm.setValue({
            name: this.name
          });
        },
        error => {
          this.error = true;
        }
      );
  }

  openUpdateTypeModal() {
    this.getOrgType();
    document.getElementById('openUpdateTypeModal').click();
  }

  getOrgType() {
    this.organisationService.details(this.organisationId)
      .pipe(first())
      .subscribe(
        data => {
          const org = data.data.organisation;
          // org type
          this.orgType = org.type;
          this.updateTypeForm.setValue({
            type: this.orgType
          });
        },
        error => {
          this.error = true;
        }
      );
  }

  openUpdateDomainsModal() {
    this.getOrgDomains();
    document.getElementById('openUpdateDomainsModal').click();
  }

  getOrgDomains() {
    this.domainRows = [];
    this.organisationService.details(this.organisationId)
      .pipe(first())
      .subscribe(
        data => {
          const org = data.data.organisation;

          // domain
          let domainString = org.domains.split(',');
          for (let index = 0; index < domainString.length; ++index) {
            this.domainRows.push({
              id: 0,
              sequence: this.domainRows.length + 1,
              text: domainString[index].trim()
            });
          }
        },
        error => {
          this.error = true;
        }
      );
  }

  openUpdateFreeTrialsModal() {
    this.getOrgFreeTrials();
    document.getElementById('openUpdateFreeTrialsModal').click();
  }

  getOrgFreeTrials() {
    this.freeTrialRows = [];
    this.organisationService.details(this.organisationId)
      .pipe(first())
      .subscribe(
        data => {
          const org = data.data.organisation;
          // free trials
          let freeTrialString = org.free_trials.split(',');
          for (let index = 0; index < freeTrialString.length; ++index) {

            this.freeTrialRows.push({
              id: 0,
              sequence: this.freeTrialRows.length + 1,
              text: freeTrialString[index].trim()
            });

            if (index == 0) {
              this.freeTrialDisplay = freeTrialString[index].trim();
            }

            if (index == 1) {
              this.freeTrialDisplay = this.freeTrialDisplay + " and more...";
            }
          }
        },
        error => {
          this.error = true;
        }
      );
  }

  openUpdateVouchersModal() {
    this.getOrgVouchers();
    document.getElementById('openUpdateVouchersModal').click();
  }

  openTotalUsersModal() {
    document.getElementById('openTotalUsersModal').click();
  }

  getOrgVouchers() {
    this.voucherRows = [];
    this.organisationService.details(this.organisationId)
      .pipe(first())
      .subscribe(
        data => {
          const org = data.data.organisation;
          // vouchers
          let voucherArray = org.vouchers;
          if (voucherArray.length == 0) {
            this.addVoucherRow();
          } else {
            for (let index = 0; index < voucherArray.length; ++index) {
              if (index == 0) { this.voucherString = voucherArray[index].code; }
              if (index == 1) { this.voucherString = this.voucherString + " and more..."; }
              let expiry = this.datePipe.transform(voucherArray[index].expiry_date * 1000, 'dd-MM-yyyy +1200');
              this.voucherRows.push({code: voucherArray[index].code,
                expiry_date: expiry,
                max_users: voucherArray[index].max_users,
                current_users: voucherArray[index].current_users,
                new: false });
            }
          }
        },
        error => {
          this.error = true;
        }
      );
  }

}
